// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as App$BenfaerberBlog from "./App.bs.js";
import * as Css$BenfaerberBlog from "./Css.bs.js";

Css$BenfaerberBlog.importFile("index.css");

var rootQuery = document.querySelector("#root");

if (!(rootQuery == null)) {
  var reactRoot = Client.createRoot(rootQuery);
  reactRoot.render(JsxRuntime.jsx(React.StrictMode, {
            children: JsxRuntime.jsx(App$BenfaerberBlog.make, {})
          }));
}

var rootQuery$1 = (rootQuery == null) ? undefined : Caml_option.some(rootQuery);

export {
  rootQuery$1 as rootQuery,
}
/*  Not a pure module */
